<template>
  <div>
    <HeaderIndex></HeaderIndex>
    <div class="body">
      <div class="image_area">
        <div class="canvas-pad" v-loading="loading">
          <div class="board">
            <div class="delete iconfont" v-show="originalImage" @click="clearImage()">&#xe63a;</div>
            <div class="file">
              <div @dragover.prevent @drop="handleDragUpload" @click="$refs.fileInput.click()">
                <input type="file" accept="image/*" ref="fileInput" @change="handleOpenImage" v-show="false" />
                <span v-show="!originalImage"> 拖拽或打开上传图片</span>
              </div>
            </div>
            <div class="brush">
              <label for="brushSize" class="iconfont">&#xe676; 画笔大小:</label>
              <div class="slider">
                <el-slider v-model="brushSize" :max="99"></el-slider>
              </div>
              <span>{{ formattedBrushSize }}</span>
            </div>
            <div>
              <canvas ref="canvas" width="840" height="1175" @mousedown="startDrawing" @mousemove="draw"
                @mouseup="stopDrawing">
              </canvas>
            </div>
            <div class="controls">
              <button class="iconfont" @click="saveDrawing">&#xe63c; 保存</button>
              <button class="iconfont" @click="cancelDrawing">&#xe63d; 取消</button>
              <button class="iconfont" @click="toggleEraser">&#xe68a; {{ isErasing ? '关闭橡皮擦' : '启用橡皮擦' }}</button>
            </div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="parameters">
          <div class="document">
            <div class="top_tips_01 iconfont">&#xe605; 文档输入说明</div>
            <span title="点击观看操作视频" @click="show_video">&nbsp;[点击观看操作视频]</span>
          </div>
          <div class="describe">
            <textarea name="" disabled="false" id="">开发者提示：此功能为涂一涂消除内容, 支持文字和图片内容反复修改。
            请勿出现非法内容如:色情、政治、暴力、毒品、法律条文、重要合同,仅用于辅助工作或学习,自觉遵守互联网健康使用规则。
            </textarea>
          </div>
          <div class="start iconfont" @click="start_process">&#xe632; 开始任务</div>
          <div class="disscuss_area">
            <div class="disscuss iconfont" @click="handelDissvisible(1)">&#xe67c; 讨论区</div>
            <div class="disscuss iconfont" @click="handelDissvisible(2)">&#xe66c; 返图区</div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="panel">
          <div class="show iconfont">&#xe76d; 显示面板</div>
          <img v-if="processedImage" :src="processedImage" alt="">
          <div class="copy_path iconfont" title="复制图像地址" @click="copy_path(processedImage)">&#xe660; 复制</div>
          <div v-if="tips" class="tips">{{ tips }}</div>
          <div v-if="tips" class="mask"></div>
        </div>
      </div>
    </div>
    <ImageModal class="modal" :visible="isModalVisible" :img_url="imageUrl" @update:visible="isModalVisible = $event"
      :img_show="false" :video_show="true" :video_src="video_src">
    </ImageModal>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>
import { genOssImage } from '@/utils/ossPath'
import { v4 as uuidv4 } from 'uuid'
import random from 'random'
import { Message } from 'element-ui'
import { genPrompt } from '@/api/prompt'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { AI_REMOVE_CONTAINER } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'
import getImageDimensions from '@/utils/getImageDimensions'
import theme from '@/utils/theme'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'RemoveContainer',
  data() {
    return {
      value: false,
      imageSrc: '',
      imagePath: '',
      maskPath: '',
      processedImage: '',
      tips: null,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',
      guidance: 3.5,
      positive: '',
      loading: false,
      day: theme.day,
      night: theme.night,
      theme: true,
      ctx: null,
      originalImage: null, // 原始图像数据
      currentImage: null, // 当前图像数据（可能包含涂鸦）
      isDrawing: false,
      isErasing: false, // 是否处于橡皮擦模式
      drawingHistory: [], // 涂鸦历史记录（可用于撤销等）
      brushSize: 10, // 默认画笔大小
      afterimage: null,
      translate: true,
      // 防呆设计
      isModalVisible: false,
      imageUrl: '',
      img_show: false,
      video_src: '',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null
    }
  },
  created() {
    this.imagePath = localStorageUtils.getItem('repair')
    this.processedImage = localStorageUtils.getItem('repair_showimage')
    // 将ID值赋给讨论区类型
    this.disscussType = AI_REMOVE_CONTAINER
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
  },
  mounted() {
    this.ctx = this.$refs.canvas.getContext('2d')
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
    this.$nextTick(() => {
      this.source_html()
    })
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 修改dissboard的状态
    handelDissvisible(x) {
      if (x === 1) {
        this.boardvisible = true
      }
      if (x === 2) {
        Message.warning('😋开发者功能暂未开放,敬请期待~!')
      }
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 防呆设计
    show_video(event) {
      event.preventDefault()
      event.stopPropagation()
      this.isModalVisible = true
      this.video_src = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/wan_move_show_video/AI%E6%99%BA%E8%83%BD%E4%BF%AE%E5%A4%8D.mp4'
    },
    // 复制图像地址
    async copy_path(path) {
      if (!path) {
        Message.error('图像地址为空,请确认是否生成图像！')
        return
      }
      try {
        // 不兼容已弃用
        // await navigator.clipboard.writeText(path)

        // 兼容性更好
        const textarea = document.createElement('textarea')
        textarea.value = path
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('复制内容成功,可进行下一步操作！')
      } catch {
        Message.error('复制内容失败,请稍后再试！')
      }
    },
    // 切换输入方式
    toggleinput() {
      this.translate = !this.translate
      Message.success(this.translate ? '翻译已开启,请用中文输入模式!' : '翻译已关闭,请用英文输入模式!')
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + D
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault() // 阻止默认行为（可选）
        this.start_process() // 执行返回主页的操作
      }
    },
    toggleEraser() {
      this.isErasing = !this.isErasing
      this.ctx.strokeStyle = this.isErasing ? '#ffffff' : 'black'
    },
    draw(e) {
      if (!this.isDrawing) return
      // 获取 canvas 实际绘制区域的尺寸
      const rect = this.$refs.canvas.getBoundingClientRect()
      const scaleX = this.$refs.canvas.width / rect.width
      const scaleY = this.$refs.canvas.height / rect.height

      const x = Math.round((e.clientX - rect.left) * scaleX)
      const y = Math.round((e.clientY - rect.top) * scaleY)

      this.ctx.lineTo(x, y)
      this.ctx.strokeStyle = this.isErasing ? '#ffffff' : 'black'
      this.ctx.lineWidth = this.brushSize
      this.ctx.lineCap = 'round'
      this.ctx.stroke()
    },
    // 处理拖拽上传图片
    handleDragUpload(event) {
      const file = event.dataTransfer.files[0]
      console.log(file)
      this.processImage(file)
      if (file && file.type.startsWith('image/')) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            const canvas = this.$refs.canvas
            const ctx = canvas.getContext('2d')
            canvas.width = img.width
            canvas.height = img.height
            ctx.drawImage(img, 0, 0)
            // 保存原始图像数据
            this.originalImage = ctx.getImageData(0, 0, canvas.width, canvas.height)
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    // 处理打开图片
    handleOpenImage(event) {
      const file = event.target.files[0]
      this.processImage(file)
      if (file && file.type.startsWith('image/')) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            const canvas = this.$refs.canvas
            const ctx = canvas.getContext('2d')
            canvas.width = img.width
            canvas.height = img.height
            ctx.drawImage(img, 0, 0)
            // 保存原始图像数据
            this.originalImage = ctx.getImageData(0, 0, canvas.width, canvas.height)
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    startDrawing(e) {
      if (this.originalImage) {
        this.isDrawing = true
        const rect = this.$refs.canvas.getBoundingClientRect()
        const scaleX = this.$refs.canvas.width / rect.width
        const scaleY = this.$refs.canvas.height / rect.height
        const x = Math.round((e.clientX - rect.left) * scaleX)
        const y = Math.round((e.clientY - rect.top) * scaleY)

        this.drawingHistory.push(this.ctx.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height))
        this.ctx.beginPath()
        this.ctx.moveTo(x, y)
      }
    },
    stopDrawing() {
      if (this.originalImage) {
        this.isDrawing = false
        this.ctx.closePath()
      }
    },
    saveDrawing() {
      if (this.originalImage) {
        // 获取 canvas 上的图像数据并转为 Base64 图片地址
        const canvas = this.$refs.canvas
        const imageDataURL = canvas.toDataURL('image/png') // 可以改为 'image/jpeg' 来压缩图片
        // this.afterimage = imageDataURL
        const filename = new Date().getTime() + '.png'
        // 转换为 Blob 对象
        fetch(imageDataURL)
          .then(res => res.blob())
          .then(blob => {
            // 创建文件对象
            const file = new File([blob], filename, { type: 'image/png' })
            this.maskImage(file)
          })
      }
    },
    cancelDrawing() {
      if (this.originalImage) {
        this.ctx.putImageData(this.originalImage, 0, 0)
        Message.error('涂鸦已取消,请使用画笔重新进行修改!')
      }
    },
    undo() {
      if (this.drawingHistory.length > 0) {
        const lastState = this.drawingHistory.pop()
        this.ctx.putImageData(lastState, 0, 0)
      }
    },
    clearImage() {
      const canvas = this.$refs.canvas
      this.ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.originalImage = null
      this.imagePath = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('repair')
      localStorage.removeItem('repair_showimage')
      window.location.reload()
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/'
      const fileName = file.name
      console.log('上传到OSS:', tmp + fileName)
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    //  图片处理函数
    async processImage(file) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)
      // 获取图片尺寸并加以限制
      try {
        const imageSize = await getImageDimensions(imageUrl)
        // console.log('图片尺寸:', imageSize.width, 'x', imageSize.height)
        if (imageSize.width > 1600 || imageSize.height > 1600) {
          Message.error('图片尺寸过大,请重新上传!建议分辨率为1600*1600以内')
          this.loading = false
          this.originalImage = null
          this.currentImage = null
          const canvas = this.$refs.canvas
          this.ctx.clearRect(0, 0, canvas.width, canvas.height)
          this.originalImage = null
          this.imagePath = ''
          this.processing = false
          this.tips = false
          localStorage.removeItem('kongtext_v2')
          this.loading = false
          return
        }
      } catch (error) {
        Message.error('获取图片尺寸失败:', error)
      }
      if (imageUrl) {
        this.imagePath = imageUrl // 更新图片路径为OSS的URL
        // console.log(imageUrl, typeof imageUrl)
        localStorageUtils.setItem('repair', imageUrl)
        Message.success('图片加载成功,可以准备开始任务!')
      } else {
        Message.error('图片上传失败,请检查网络配置!')
      }
      // 同时显示本地预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(file)
      this.loading = false
    },
    async maskImage(file) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)
      if (imageUrl) {
        this.maskPath = imageUrl // 更新图片路径为OSS的URL
        this.loading = false
        Message.success('已正确保存涂鸦内容,可以开始点击执行任务!')
      }
    },
    // 应用函数
    start_process() {
      this.processedImage = ''
      if (this.originalImage === '' || this.originalImage === null) {
        Message.warning('请先选择图像文件')
        return
      }
      if (this.imagePath === '' || this.imagePath === null) {
        Message.warning('请先选择图像文件')
        return
      }
      if (this.maskPath === '' || this.maskPath === null) {
        Message.warning('请先保存涂鸦的图像文件,再次尝试开始任务!')
        return
      }

      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      this.processing = true
      this.tips = '任务正在生成,预计等待35-50S.....'
      const seed = Math.floor(Math.random() * 10000000000000000)
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const promptData = {
        3: {
          inputs: {
            vae_name: 'ae.safetensors'
          },
          class_type: 'VAELoader',
          _meta: {
            title: 'Load VAE'
          }
        },
        5: {
          inputs: {},
          class_type: 'FluxKontextImageScale',
          _meta: {
            title: 'FluxKontextImageScale'
          }
        },
        8: {
          inputs: {
            text: 'Remove the content in the picture.',
            clip: [
              '25',
              0
            ]
          },
          class_type: 'CLIPTextEncode',
          _meta: {
            title: 'CLIP Text Encode (Positive Prompt)'
          }
        },
        10: {
          inputs: {
            guidance: 2.5,
            conditioning: [
              '8',
              0
            ]
          },
          class_type: 'FluxGuidance',
          _meta: {
            title: 'FluxGuidance'
          }
        },
        13: {
          inputs: {
            seed: seed,
            steps: 20,
            cfg: 1,
            sampler_name: 'euler',
            scheduler: 'simple',
            denoise: 1,
            model: [
              '24',
              0
            ],
            positive: [
              '22',
              0
            ],
            negative: [
              '10',
              0
            ],
            latent_image: [
              '22',
              1
            ]
          },
          class_type: 'KSampler',
          _meta: {
            title: 'KSampler'
          }
        },
        14: {
          inputs: {
            samples: [
              '13',
              0
            ],
            vae: [
              '3',
              0
            ]
          },
          class_type: 'VAEDecode',
          _meta: {
            title: 'VAE Decode'
          }
        },
        22: {
          inputs: {
            noise_mask: true,
            conditioning: [
              '10',
              0
            ],
            vae: [
              '3',
              0
            ],
            pixels: [
              '39',
              0
            ],
            mask: [
              '43',
              0
            ]
          },
          class_type: 'Kontext Inpainting Conditioning',
          _meta: {
            title: 'Kontext Inpainting Conditioning'
          }
        },
        24: {
          inputs: {
            model_path: 'svdq-int4_r32-flux.1-kontext-dev.safetensors',
            cache_threshold: 0,
            attention: 'nunchaku-fp16',
            cpu_offload: 'auto',
            device_id: 0,
            data_type: 'bfloat16',
            i2f_mode: 'enabled'
          },
          class_type: 'NunchakuFluxDiTLoader',
          _meta: {
            title: 'Nunchaku FLUX DiT Loader'
          }
        },
        25: {
          inputs: {
            model_type: 'flux',
            text_encoder1: 't5xxl_fp8_e4m3fn.safetensors',
            text_encoder2: 'clip_l.safetensors',
            t5_min_length: 512,
            use_4bit_t5: 'disable',
            int4_model: 'none'
          },
          class_type: 'NunchakuTextEncoderLoader',
          _meta: {
            title: 'Nunchaku Text Encoder Loader (Deprecated)'
          }
        },
        38: {
          inputs: {
            filename: filename,
            access_key_id: OSS_ACCESS_KEY_ID,
            access_key_secret: OSS_ACCESS_KEY_SECRET,
            security_token: '',
            bucket_name: 'mj-comfy-ui',
            endpoint: 'oss-cn-shenzhen.aliyuncs.com',
            image: [
              '14',
              0
            ]
          },
          class_type: 'AC_Oss上传图像',
          _meta: {
            title: 'AC_Oss上传图像'
          }
        },
        39: {
          inputs: {
            image_url: this.imagePath
          },
          class_type: 'AC_从URL加载图像',
          _meta: {
            title: '原始图片'
          }
        },
        40: {
          inputs: {
            image_url: this.maskPath
          },
          class_type: 'AC_从URL加载图像',
          _meta: {
            title: '遮罩'
          }
        },
        41: {
          inputs: {
            channel: 'red',
            image: [
              '40',
              0
            ]
          },
          class_type: 'AC_Img2Mask',
          _meta: {
            title: 'AC_Img2Mask'
          }
        },
        43: {
          inputs: {
            mask: [
              '41',
              0
            ]
          },
          class_type: 'InvertMask',
          _meta: {
            title: 'InvertMask'
          }
        }
      }
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          this.processing = false
          return null
        }
      }

      const fetchImageFilename = async (promptId) => {
        try {
          // 直接使用该实例请求历史记录
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          // const response = await getImagePathByPrompt(promptId)
          // const promptInfo = response[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 38 // prompt信息组件名的下标

          console.log(promptInfo)
          if (promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)

            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('repair_showimage', imagepath)
            this.getTaskEnd(imagepath, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
          } else {
            console.error('获取历史记录失败，状态码：', response.status)
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
        }
      }

      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: AI_REMOVE_CONTAINER
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              console.log(`这是返回${msg}`)

              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  // console.log('执行完成')
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
            }
          }
        }
        this.ws.onclose = async () => {
          // console.log('与后台链接断开')
          this.processing = false
          this.tips = false
          try {
            // 恢复cuda为空闲状态
            const index = cudaIndexNum()
            // console.log('回复当前cuda状态', index)
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }

      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    async getTaskEnd(tmp, taskLogId) {
      const imgInfo = await getImageSizeByLoading(tmp)
      const info = {
        details: [{ path: tmp, imgInfo: imgInfo }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.image_area')
      main.style.opacity = this.theme === false ? 0.75 : 1
    }
  },
  computed: {
    formattedBrushSize() {
      return this.brushSize < 10 ? '0' + this.brushSize : this.brushSize
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

.drawing-canvas {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: auto;
  z-index: 10;
}

::v-deep {
  .el-slider__runway {
    height: 8px;
    border-radius: 8px;
    background-color: @font_gray;
  }

  .el-slider__bar {
    height: 8px;
    background-color: @morejoy;
  }

  .el-slider__button {
    position: absolute;
    top: 16%;
    width: 10px;
    height: 26px;
    border-radius: 20%;
    background-color: @morejoy;
    border: 1px solid @morejoy;
  }
}

canvas {
  position: absolute;
  width: 840px;
  height: auto;
  top: 50%;
  transform: translateY(-50%);
}

.canvas-pad {
  display: flex;
  width: 840px;
  height: calc(100vh - 100px);

  .board {
    position: relative;
    width: 840px;
    height: auto;
    border-radius: 25px;
    background-color: @basicselect;
    overflow: hidden;
    transition: all 0.5s;

    .delete {
      position: absolute;
      right: 25px;
      top: 120px;
      font-size: 30px;
      background-color: @morejoy;
      color: @font_white;
      padding: 10px;
      border-radius: @border_radius_2;
      z-index: 4;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        font-size: 32px;
      }
    }

    .file {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;

      input {
        font-size: 23px;
      }

      span {
        display: inline-block;
        padding: 40px;
        font-size: 25px;
        font-family: 'icomoon';
        cursor: pointer;
        transition: all 0.5s;

        &:active {
          font-size: 27px;
          transition: all 0.5s;
        }
      }
    }

    .brush {
      position: absolute;
      display: flex;
      gap: 0 10px;
      width: 365px;
      z-index: 3;
      top: 25px;
      right: 25px;
      font-size: 23px;
      background-color: rgba(255, 255, 255, 0.281);
      backdrop-filter: blur(10px);
      border-radius: @border_radius_2;
      padding: 10px;

      .slider {
        width: 150px;
      }

      span {
        margin-left: 5px;
      }
    }

    .controls {
      position: absolute;
      width: 380px;
      height: 60px;
      bottom: 10px;
      display: flex;
      left: 20px;
      gap: 10px;

      button {
        font-size: 23px;
        padding: 10px 10px;
        color: @font_white;
        z-index: 3;
        background-color: @morejoy;
        border: none;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          padding-bottom: 30px;
          transition: all 0.5s;
        }
      }
    }

    &:hover {
      transition: all 0.5s;
      box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
    }
  }
}

.brush-control {
  margin-top: 10px;
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  overflow-y: scroll;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .title {
    display: flex;
    height: 90px;
    line-height: 80px;
    justify-content: center;
    padding: 0 10px;
    padding-top: 10px;

    div {
      flex: 1;
      font-size: 25px;
      color: @font_black;
      text-align: center;
      cursor: pointer;
      border-radius: 15px;
      border: 2px solid transparent;

      &:hover {
        border: 2px dashed @basicselect;
        transition: all 0.5s;
      }
    }
  }

  .image_area {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    height: calc(100vh - 80px);
    padding: 10px;

    .canvas-pad {
      color: @font_black;
    }

    .gap {
      width: 15px;
    }

    .image_upload {
      position: relative;
      flex: 1;
      height: 100%;
      border-radius: 25px;
      background-color: @basicselect;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .tips {
        color: @font_black;
        position: absolute;
        font-size: 25px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        font-family: 'icomoon';
        z-index: 1;
        transition: all 0.5s;

        &:hover {
          font-size: 26px;
          transition: all 0.5s;
        }

        &:active {
          top: 48%;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
        }
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .delete_image {
        position: absolute;
        width: 200px;
        height: 60px;
        font-size: 25px;
        font-family: 'icomoon';
        text-align: center;
        line-height: 60px;
        background-color: @morejoy;
        color: @font_white;
        border-radius: 15px;
        top: 15px;
        right: 15px;
        z-index: 3;

        &:active {
          transition: all 0.5s;
          line-height: 50px;
        }
      }

      .paste {
        position: absolute;
        width: 200px;
        height: 60px;
        font-size: 25px;
        font-family: 'icomoon';
        text-align: center;
        line-height: 60px;
        color: @font_gray;
        border-radius: 15px;
        bottom: 15px;
        right: 15px;
        z-index: 5;
        transition: all 0.5s;

        &:active,
        &:hover {
          transition: all 0.5s;
          line-height: 50px;
        }
      }
    }

    .parameters {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      border-radius: 25px;
      align-items: center;
      height: calc(100vh - 80px);
      font-family: 'icomoon';
      gap: 10px 0;
      justify-content: center;

      .document {
        width: 720px;
        display: flex;
        font-weight: 500;

        .top_tips_01 {
          color: @font_gray;
          font-size: 24px;
          text-indent: 10px;
        }

        span {
          color: @morejoy;
          font-size: 24px;
          cursor: pointer;
        }
      }

      .tips {
        width: 700px;
        font-size: 25px;
        color: @font_gray;
      }

      .describe {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 700px;
        height: 180px;
        font-size: 25px;
        color: @font_gray;
        background-color: @basicselect;
        border: 1px solid @basicselect;
        border-radius: @border_radius;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        textarea {
          width: 100%;
          height: 100%;
          resize: none;
          font-size: 20px;
          border: none;
          border-radius: @border_radius;
          padding: 20px;
          line-height: 25px;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
        }

        &:active {
          line-height: 60px;
          width: 730px;
          height: 220px;
          transition: all 0.5s;
        }

        .translate {
          position: absolute;
          display: inline-block;
          bottom: 15px;
          right: 15px;
          color: @font_gray;
          font-size: 23px;
          z-index: 2;
        }
      }

      .guidance {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 700px;
        height: 100px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: 15px;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        input {
          width: 180px;
          height: 35px;
          font-size: 20px;
          border: 1px solid @basicselect;
          border-radius: 5px;
          text-align: center;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 720px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .start {
        width: 700px;
        height: 100px;
        font-size: 25px;
        text-align: center;
        line-height: 100px;
        font-family: 'icomoon';
        border-radius: 15px;
        background-color: @basicselect;
        color: @font_black;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 420px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .disscuss_area {
        display: flex;
        width: 700px;
        height: 100px;
        gap: 10px;

        .disscuss {
          flex: 1;
          height: 100px;
          font-size: 25px;
          border-radius: @border_radius;
          background-color: @basicselect;
          text-align: center;
          line-height: 100px;
          color: @font_black;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            font-size: 27px;
            transition: all 0.5s;
            box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

          }
        }
      }
    }

    .panel {
      height: 100%;
      position: relative;
      flex: 1;
      border-radius: 25px;
      background-color: @basicselect;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .show {
        position: absolute;
        border-radius: 15px;
        background-color: @morejoy;
        width: 200px;
        height: 60px;
        font-size: 25px;
        text-align: center;
        line-height: 60px;
        top: 25px;
        left: 25px;
        z-index: 5;
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .tips {
        position: absolute;
        width: 100%;
        height: 50px;
        font-size: 25px;
        top: 50%;
        left: 6%;
        text-align: center;
        line-height: 100%;
        transition: all 0.5s;
        color: @font_black;
        font-weight: 500;
        z-index: 4;
      }

      .mask {
        width: 100%;
        height: 100%;
        background-color: @font_gray;
        z-index: 3;
      }

      .copy_path {
        position: absolute;
        text-align: center;
        right: 10px;
        bottom: 10px;
        width: 120px;
        height: 50px;
        font-size: 25px;
        color: @font_gray;
        z-index: 4;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
        }
      }
    }
  }
}
</style>
